export class ModuleOverview {
    ModuleId: number;
    CourseId: number;
    Ordinal: number;
    Title: string;
    Summary: string;
    Objectives: string[];

    constructor(init?: Partial<ModuleOverview>) {
        Object.assign(this, init);
    }
}